import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Row, Col } from 'reactstrap';
import classNames from 'classnames';
import { Form, Formik, Field, getIn } from 'formik';
import _ from 'lodash';
import FormikMaterialTextField from './FormikMaterialTextField';
import { useSelector, useDispatch } from 'react-redux';
import { locationElocService } from 'services';
import config from 'config';

const LocationModalComponent = (props) => {
  const {
    isOpen,
    toggle,
    color,
    btn,
    form: { values, setFieldValue },
    colored,
    header,
    cb,
    isSubscribed,
  } = props;
  const modalClass = classNames({
    'modal-dialog--colored': colored,
    'modal-dialog--header': header,
  });

  const token = config.mapplsAccessToken || '';

  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    let value = e.target.value;
    setInputValue(value);
  };
  const getLocationDetails = async (params) => {
    const resData = await locationElocService.getLocationDetails(params);
    return resData;
  };

  const locationLatitude = values?.address_lattitude || values?.location_details?.address_lattitude || 18.5313;
  const locationLongitude = values?.address_longitude || values?.location_details?.address_longitude || 73.8498;

  useEffect(() => {
    let map = null;

    function loadScript(url) {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${url}"]`)) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = url;
        script.async = true;

        script.onload = resolve;
        script.onerror = reject;

        document.body.appendChild(script);
      });
    }

    async function initialize() {
      await loadScript(`https://sdk.mappls.com/map/sdk/web?v=3.0&access_token=${token}`);
      await loadScript(`https://sdk.mappls.com/map/sdk/plugins?access_token=${token}&v=3.0`);

      if (!window.mappls) {
        console.error('Mappls SDK not loaded');
        return;
      }

      map = new window.mappls.Map('businessMap', {
        center: [locationLatitude, locationLongitude],
        zoom: 15,
      });

      console.log('mappls placepicker >>', window.mappls);

      map.addListener('load', () => {
        var options = {
          map,
          header: true,
          closeBtn: false,
          geolocation: true,
        };
        window.mappls.placePicker(options, callback_method);
        async function callback_method(picker) {
          if (picker?.data && picker?.data !== undefined) {
            const data = picker?.data;
            let location_code = data.formatted_address || '';

            if (data.lat === '' || data.lng === '') {
              let params = {
                place_id: data.eLoc,
                bearer_token: token,
              };

              let res = await getLocationDetails(params);
              setFieldValue('address_lattitude', parseFloat(res.latitude || 0));
              setFieldValue('address_longitude', parseFloat(res.longitude || 0));
              setFieldValue('location_code', location_code);

              let newdata = {
                ...data,
                lat: res.latitude.toString(),
                lng: res.longitude.toString(),
              };

              cb(newdata);
              toggle();
            } else {
              setFieldValue('address_lattitude', parseFloat(data.lat || 0));
              setFieldValue('address_longitude', parseFloat(data.lng || 0));
              setFieldValue('location_code', location_code);

              cb(data);
              toggle();
            }
          }
        }
      });
    }

    if (token && isOpen) {
      initialize();
    }

    // return () => {
    //   if (map?.remove) {
    //     map.remove();
    //   }
    // };
  }, [token, isOpen]);

  return (
    <div className="bfc-post-text-editor-modal">
      <div className="bfc-follow-editor-section">
        <Button className="d-none" color={color} onClick={toggle}>
          {btn}
        </Button>
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          modalClassName="ltr-support theme-light"
          className={`map-modal modal-dialog--${color} ${modalClass} `}>
          <div className="modal__header location-modal__header">
            <button aria-label="Close" className=" close" type="button" onClick={toggle}>
              <span aria-hidden>×</span>
            </button>
          </div>
          <div className="modal__body">
            <div className="locationModal-map profile-map__modal p-15">
              <div className="">
                <div
                  className={isSubscribed ? 'disableButton' : 'enableButton'}
                  id="businessMap"
                  name="businessMap"
                  style={{ backgroundColor: 'white', height: '100%', minHeight: '600px', width: '100%' }}></div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

LocationModalComponent.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  color: PropTypes.string.isRequired,
  colored: PropTypes.bool,
  header: PropTypes.bool,
  btn: PropTypes.string.isRequired,
  // rtl: RTLProps.isRequired,
};

LocationModalComponent.defaultProps = {
  title: '',
  message: '',
  colored: false,
  header: false,
  color: 'primary',
};

export default LocationModalComponent;
